import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
const { delimited, option, right } = Parser;
export class Or {
    static of(left, right) {
        return new Or(left, right);
    }
    _left;
    _right;
    constructor(left, right) {
        this._left = left;
        this._right = right;
    }
    get left() {
        return this._left;
    }
    get right() {
        return this._right;
    }
    matches(device) {
        return this._left.matches(device) || this._right.matches(device);
    }
    equals(value) {
        return (value instanceof Or &&
            value._left.equals(this._left) &&
            value._right.equals(this._right));
    }
    *iterator() {
        for (const condition of [this._left, this._right]) {
            yield* condition;
        }
    }
    [Symbol.iterator]() {
        return this.iterator();
    }
    toJSON() {
        return {
            type: "or",
            left: this._left.toJSON(),
            right: this._right.toJSON(),
        };
    }
    toString() {
        return `(${this._left}) or (${this._right})`;
    }
}
(function (Or) {
    function isOr(value) {
        return value instanceof Or;
    }
    Or.isOr = isOr;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-or}
     *
     * @internal
     */
    function parse(parseInParens, featureParser) {
        return right(delimited(option(Token.parseWhitespace), Token.parseIdent("or")), parseInParens(featureParser));
    }
    Or.parse = parse;
})(Or || (Or = {}));
//# sourceMappingURL=or.js.map